import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'semantic-ui-react'
import styled from 'styled-components'

const RELATIVE_DATE_REGEX = /^(\d+)_days_(ago|from_now)$/

// Fixed width so the digits stay visible inside the flex row — a `fluid` input
// collapses to just its spinner between the sentence words.
const NumberInput = styled(Input)`
  width: 4.5rem;
  flex: 0 0 auto;
`

export function parseRelativeDateValue(encoded) {
  if (!encoded || typeof encoded !== 'string') {
    return { days: '0', direction: 'ago' }
  }
  const match = RELATIVE_DATE_REGEX.exec(encoded)
  if (!match) {
    return { days: '0', direction: 'ago' }
  }
  return { days: match[1], direction: match[2] === 'from_now' ? 'from_now' : 'ago' }
}

export function serializeRelativeDateValue({ days, direction }) {
  const safeDirection = direction === 'from_now' ? 'from_now' : 'ago'
  return `${days}_days_${safeDirection}`
}

export function isValidRelativeDateValue(encoded) {
  return typeof encoded === 'string' && RELATIVE_DATE_REGEX.test(encoded)
}

/**
 * RelativeDateInput — a small, fixed-width, controlled number-of-days input.
 *
 * The direction (ago / from_now) and the shared days value are owned by the
 * parent (DatetimeBranch): each relative row renders one of these showing the
 * same value, and the parent handles selection + serialization. Input is given
 * an explicit width so the digits stay visible inside the flex row (a `fluid`
 * input collapses to just its spinner between the sentence words).
 */
export function RelativeDateInput({ value, onChange, onFocus }) {
  const handleChange = (_, { value: next }) => {
    onChange(next.replace(/[^0-9]/g, ''))
  }

  return (
    <NumberInput
      type="number"
      min={0}
      placeholder="number of days"
      value={value}
      onChange={handleChange}
      onFocus={onFocus}
    />
  )
}

RelativeDateInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
}

RelativeDateInput.defaultProps = {
  value: '',
  onChange: () => {},
  onFocus: () => {},
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/AudienceRuleInput/RelativeDateInput.js